import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';


const initialState: DossierState = {
    active: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
    archived: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
    dossiers: [],
    viewing_id: null,
    viewing_transports: [],
    viewing_goods: [],
    viewing_containers: [],
    viewing_documents: [],
};

const rootState: DossierState = initialState;

const getters: GetterTree<DossierState, RootState> = {
    active(state: DossierState): FvgDossierSearchResults | undefined {
        return state.active;
    },
    archived(state: DossierState): FvgDossierSearchResults | undefined {
        return state.archived;
    },
    viewing(state: DossierState): FvgDossier | undefined {
        return state.dossiers.find((dossier) => dossier.Id === state.viewing_id);
    },
    transports(state: DossierState): FvgTransport[] {
        return state.viewing_transports;
    },
    goods(state: DossierState): FvgGood[] {
        return state.viewing_goods;
    },
    containers(state: DossierState): FvgContainer[] {
        return state.viewing_containers;
    },
    documents(state: DossierState): FvgDocument[] {
        return state.viewing_documents;
    },
};

const mutations: MutationTree<DossierState> = {
    RESET(state: DossierState) {
        Object.assign(state, initialState);
    },
    SET_DOSSIERS(state: DossierState, dossiers: FvgDossier[]) {
        // @ts-ignore
        const filestatuses = this.state.lookup.filestatuses;
        state.dossiers = dossiers.map((d) => {
            return {
                ...d,
                FileStatus: filestatuses.find((FileStatus: Lookup) => FileStatus.Id === d.Status).Description,
            };
        });
    },
    SET_ACTIVE(state: DossierState, dossiers: FvgDossierSearchResults) {
        // @ts-ignore
        const filestatuses = this.state.lookup.filestatuses;
        state.active.Meta = dossiers.Meta;
        const mappedDossiers = dossiers.Results.map((d: FvgDossier) => {
            return {
                ...d,
                FileStatus: filestatuses.find((FileStatus: Lookup) => FileStatus.Id === d.Status).Description,
            };
        });

        // @ts-ignore
        state.active.Results = state.active.Results.concat(mappedDossiers);
    },
    SET_VIEWING(state: DossierState, id: number) {
        state.viewing_id = id;
    },
    SET_VIEWING_TRANSPORTS(state: DossierState, transports: FvgTransport[]) {
        // @ts-ignore
        const transportModes = this.state.lookup.transportmodes;
        state.viewing_transports = transports.map((t) => {
            return {
                ...t,
                Mode: transportModes.find((mode: Lookup) => mode.Id === t.TransportMode).Description,
            };
        });
    },
    SET_VIEWING_GOODS(state: DossierState, goods: FvgGood[]) {
        state.viewing_goods = goods;
    },
    SET_VIEWING_CONTAINERS(state: DossierState, containers: FvgContainer[]) {
        state.viewing_containers = containers;
    },
    SET_VIEWING_DOCUMENTS(state: DossierState, documents: FvgDocument[]) {
        // @ts-ignore
        const documenttypes = this.state.lookup.documenttypes;
        state.viewing_documents = documents.map((t) => {
            return {
                ...t,
                Type: documenttypes.find((type: Lookup) => type.Id === t.DocumentType).Description,
            };
        });
    },
    SET_ALLOW_BOOKING(state: DossierState, id: number) {
        const index = state.dossiers.findIndex((dossier: FvgDossier) => dossier.Id === id);
        if (index !== -1) {
            // @ts-ignore
            this._vm.$set(state.dossiers[index], 'AllowBooking', false);
        }
    },
};

const actions: ActionTree<DossierState, RootState> = {
    read({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`files/${id}`)
            .then((data: ApiResponseFile) => {
                commit('SET_DOSSIERS', [data.data]);
                commit('SET_VIEWING', data.data.Id);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readActive({ commit }, page: number): any {
        if (!page) {
            page = 1;
        }
        // @ts-ignore
        return this._vm.$api.get(`files?status=active&page=${page}`)
            .then((data: ApiResponseFile) => {
                commit('SET_ACTIVE', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readTransports({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`files/${id}/transports`)
            .then((data: ApiResponseTransport) => {
                commit('SET_VIEWING_TRANSPORTS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readGoods({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`files/${id}/goods`)
            .then((data: ApiResponseGood) => {
                commit('SET_VIEWING_GOODS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readContainers({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`files/${id}/containers`)
            .then((data: ApiResponseContainer) => {
                commit('SET_VIEWING_CONTAINERS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readDocuments({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`files/${id}/documents`)
            .then((data: ApiResponseDocument) => {
                commit('SET_VIEWING_DOCUMENTS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    downloadFile({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`/documents/${id}/uri`)
            .then((data: ApiResponseDocument) => {
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    allowBooking({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.post(`/files/${id}/allowbooking`)
            .then((data: any) => {
                commit('SET_ALLOW_BOOKING', id);
                return Promise.resolve(data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    updateReference({ commit }, payload): any {
        // @ts-ignore
        return this._vm.$api.post(`/files/${payload.Id}`, payload)
            .then((data: any) => {
                return Promise.resolve(data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    containerDeliveryRequest({ commit }, payload: { ContainerNr: string, DeliveryDate: string }): any {
        // @ts-ignore
        return this._vm.$api.post(`/containers/deliveryrequest`, payload)
            .then((data: any) => {
                return Promise.resolve(data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
